import { Column, CreateDateColumn, Entity, PrimaryGeneratedColumn } from "typeorm";

@Entity('allocated_sale_orders')
export class AllocatedSoEntity {

  @PrimaryGeneratedColumn("increment",{name:'allocated_so_stock_id'})
  allocatedSoStockId:number;

  @Column('int',{
    name:'allocated_so_id',
    nullable:false
  })
  allocatedSoId : number
  
  @Column('int',{
    name:'allocated_so_item_id',
    nullable:false
  })
  allocatedSoItemId : number

  
  @Column('int',{
    name:'stock_id',
    nullable:false
  })
  stockId : number

  @Column('int',{
    name:'allocated_cartons'
  })
  allocatedCartons: number

  
  @Column('int',{
    name:'allocated_loose_pouches'
  })
  allocatedLoosePouches: number

  @Column('decimal',{
    name:'total_quantity',
    precision:10,scale:3,
    unsigned:true,
  })
  totalQuantity: number

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "created_user",
      length:50,
      default:"Admin",
  })
  createdUser: string | null;

}